import {
  Button,
  Grid,
  Typography
} from "@mui/material";

import Section from "./components/Section";
import DetailGrid from "./components/DetailGrid"
import DistributorBiddersForm from "./forms/DistributorBiddersForm";

import { useData } from "../../hooks/useData";
import { useState } from "react";

const getDetailGridProps = ({ bidders, loading, totalBiddersCount, bidder_ids_updated_at }) => {
  const totalBiddersAssigned = bidders?.length || 0
  const totalSelectableBiddersCount = totalBiddersCount + bidders.filter(({ active }) => [false, "false"].includes(active)).length

  const badgeState = loading ? "loading" : (
    totalBiddersAssigned > 0 ? "checked" : "unchecked"
  );

  const props = {
    badgeState,
    columns: [
      { title: "Total Bidders", description: `${totalBiddersAssigned} of ${totalSelectableBiddersCount} bidders enabled` },
      { title: "Last Modified", description: bidder_ids_updated_at ?? "-" }
    ]
  }

  return props
}

const EditButton = ({ onClick }) => (
  <Button sx={{ alignSelf: "self-end" }} variant="contained" size="small" onClick={onClick}>Edit</Button>
)

const DistributorBiddersSection = ({ distributor }) => {
  const { loading, data } = useData("player", "/api/programmatic_supply/bidders", { active_only: true });
  const [isEditing, setIsEditing] = useState(false);

  const handleEditClick = (event) => setIsEditing((prev) => !prev);

  return (
    <Section title={"Bidder Settings"} actionButton={<EditButton onClick={handleEditClick} />}>
      <Grid container item xs={12}>
        <Grid item xs={12} sx={{ mb: 2.5 }}>
          <Typography variant="subtitle1" color="rgb(0,0,0,0.60)">Eligible Bidders</Typography>
        </Grid>
        <Grid item xs={12} sx={{ borderRadius: 2, display: "flex", flexDirection: "row" }}>
          {isEditing ? (
            <DistributorBiddersForm distributor={distributor} bidders={data?.records || []} onCancel={handleEditClick} />
          ) : (
            <DetailGrid
              {...getDetailGridProps({ ...distributor, loading, totalBiddersCount: data?.pagination?.total_count || 0 })}
            />
          )} 
        </Grid>
      </Grid>
    </Section>
  )
}

export default DistributorBiddersSection;
